<div class="tooltip-content" [class.template-mode]="template">
  @if (template) {
    <ng-container [ngTemplateOutlet]="template" [ngTemplateOutletContext]="templateContext"></ng-container>
  } @else {
    <div [innerHTML]="sanitizedContent"></div>
  }
</div>
